<app-loader></app-loader>
<app-sidebar *ngIf="isFullLayout"></app-sidebar>
<div class="body-container" [ngClass]="isFullLayout ? 'padding-app' : ''">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
